"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryCreate = void 0;
require("./inventory-create.less");
const React = require("react");
const moment = require("moment");
const floating_page_1 = require("client/components/page/floating-page");
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const select_1 = require("client/components/material/select");
const switch_1 = require("client/components/material/switch");
const router_1 = require("client/components/router");
const ui_1 = require("client/components/ui");
const loading_indicator_1 = require("client/components/ui/loading-indicator");
const warning_1 = require("client/components/icons/warning");
const mobx_1 = require("mobx");
const throttle_debounce_1 = require("throttle-debounce");
const store_1 = require("client/modules/inventory/modules/inventory-create/store");
const store_2 = require("../inventory-search/store");
const mobx_react_1 = require("mobx-react");
const store_3 = require("client/modules/users/store");
let InventoryCreate = class InventoryCreate extends React.Component {
    constructor() {
        super(...arguments);
        this.addToAllSites = false;
        this.ndcs = [];
        this.productwithPackage = {};
        this.handleInputChange = throttle_debounce_1.debounce(500, async (value) => {
            if (value === "")
                return;
            await store_2.inventorySearchStore.loadFTS(value.toLowerCase());
        });
        this.handleCancel = () => {
            router_1.RouteManager.transitionTo("/formulary");
        };
        this.handleManualInput = () => {
            router_1.RouteManager.transitionTo("/formulary/new/manual");
        };
        this.handleSubmit = async () => {
            if (!this.inventory.ndc) {
                this.missing.ndc = true;
            }
            else {
                const inventory = await store_1.inventoryCreateStore.createInventory(this.addToAllSites, this.inventory);
                if (inventory) {
                    router_1.RouteManager.transitionTo(`/formulary/${this.addToAllSites ? "0" : "new"}/${inventory.id}`);
                }
            }
        };
        this.handleSelect = async (value) => {
            await store_2.inventorySearchStore.loadFTS(value, "single");
            const pkg = store_2.inventorySearchStore.fdb[0];
            this.inventory.ndc = pkg.NDC;
            this.inventory.data = pkg;
        };
        this.handleToggle = () => {
            this.addToAllSites = !this.addToAllSites;
        };
    }
    async componentDidMount() {
        this.inventory = {
            data: [],
            expireDate: moment().toDate(),
            lotNum: "",
            ndc: ""
        };
        await store_2.inventorySearchStore.loadFTS("");
        this.missing = {
            ndc: false
        };
    }
    get availableOptions() {
        const a = store_2.inventorySearchStore.fdb;
        return a
            ? a.map((pkg, i) => {
                const pkgName = pkg.LabelName;
                const ndc = pkg.NDC;
                const { index } = pkg;
                return {
                    id: i,
                    label: `${pkgName} - ${ndc}`,
                    value: `${index}`
                };
            })
            : [];
    }
    render() {
        var _a, _b;
        return (React.createElement("div", { className: "inventory" }, store_3.usersStore.permissions.CreateFormulary ? (React.createElement(React.Fragment, null,
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement("div", { className: "inventory__title-wrapper" },
                    React.createElement(kpi_title_1.KpiTitle, { label: "Add Medication" }))),
            React.createElement(floating_page_1.FloatingPage, null,
                React.createElement("div", { className: "inventory__form" },
                    React.createElement(ui_1.UiForm, { buttons: [
                            React.createElement(ui_1.UiButton, { key: "btnerino", onClick: this.handleCancel }, "Cancel"),
                            "Next"
                        ], loading: store_1.inventoryCreateStore.inventory.loading, onSubmit: this.handleSubmit, error: store_1.inventoryCreateStore.inventory.error },
                        React.createElement("div", { className: "inventory__form__description" },
                            "What is the NDC of the medication you want to add to your inventory?",
                            React.createElement("div", { className: "manual" },
                                React.createElement(ui_1.UiButton, { primary: true, onClick: this.handleManualInput }, "Manual Input"))),
                        React.createElement("div", { className: "create-form" },
                            React.createElement(select_1.MaterialSelect, { label: "NDC *", missing: (_a = this.missing) === null || _a === void 0 ? void 0 : _a.ndc, options: this.availableOptions, searchable: true, onInputChange: this.handleInputChange, onSelect: this.handleSelect, value: ((_b = this.inventory) === null || _b === void 0 ? void 0 : _b.ndc) || "" }),
                            store_1.inventoryCreateStore.ndcs.loading ? (React.createElement(loading_indicator_1.UiLoadingIndicator, null)) : ("")),
                        React.createElement("div", { className: "switch-add-all-sites" },
                            React.createElement(switch_1.MaterialSwitch, { label: "Add to all pharmacies", value: "Add to all pharmacies", onChange: this.handleToggle })),
                        React.createElement("div", { className: "inventory__form__description", style: { marginTop: "20px" } },
                            React.createElement("div", { className: "flexContainer" },
                                React.createElement(warning_1.WarningIcon, { style: { marginRight: "15px", width: "50px" } }),
                                "If the medication you are looking for does not exist in the search above then it was not within the First Databank Database. You can add the medication information manually by pressing Manual Input button above."))))))) : (store_3.usersStore.showLock())));
    }
};
__decorate([
    mobx_1.observable
], InventoryCreate.prototype, "addToAllSites", void 0);
__decorate([
    mobx_1.observable
], InventoryCreate.prototype, "inventory", void 0);
__decorate([
    mobx_1.observable
], InventoryCreate.prototype, "ndcs", void 0);
__decorate([
    mobx_1.observable
], InventoryCreate.prototype, "missing", void 0);
__decorate([
    mobx_1.observable
], InventoryCreate.prototype, "productwithPackage", void 0);
__decorate([
    mobx_1.computed
], InventoryCreate.prototype, "availableOptions", null);
InventoryCreate = __decorate([
    mobx_react_1.observer
], InventoryCreate);
exports.InventoryCreate = InventoryCreate;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-create/inventory-create.tsx
// module id = 3459
// module chunks = 0